"use client"
import React from 'react';
import Link from "next/link";
import CheckCircleIconCpt from "@/app/clients/icons/CheckCircleIcon";
import ProductPrice from "@/app/components/Price";
import Image from 'next/image';
import WhatsAppButton from './buttons/WhatsAppButton';
import ImageContainer from '../products/[slug]/ImageContainer';
import Product from '../models/Product';

const styleBox = {
    border: 'solid 1px #f7f7f7',
    display: 'inline-block',
    background: '#f7f7f7',
    borderRadius: '10px',
    overflow: 'hidden'
}

export default function ProductPageWraper({ el }: { el: Product }) {

    return (
        <div >
            <div className="mt-9">
                <h2 className="text-xl font-bold flex items-center">
                    <Link href="/">

                    </Link>
                    <span
                        className="ml-3 text-[1.2rem] sm:text-[2rem] md:text-[2.5rem]"
                        style={{
                            fontFamily: "inherit",
                            letterSpacing: "1px",
                        }}
                    >
                        {el.name}
                    </span>
                </h2>
            </div>


            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

                <div className="col-span-1 md:col-span-1">
                    <ImageContainer product={el} />
                </div>




                <div className="col-span-1 md:col-span-1">
                    <div className="pl-0 md:pl-9">


                        <p className="mt-3">{el.description}</p>


                        {el.moreDetails && (
                            <ul className="list-none pl-0 mt-3">
                                {el.moreDetails.map((d, index) => (
                                    <li key={index} className="flex items-center mb-3">
                                        <CheckCircleIconCpt />
                                        {d}
                                    </li>
                                ))}
                            </ul>
                        )}

                        <div className="mt-4">
                            <ProductPrice product={el} showPromoPrice={true} />
                        </div>


                        {
                            (el.promoPrice < 400) ? (
                                <div className="mt-4 font-bold i bg-[#ffe4b7] px-[5px] py-[2px] rounded-[6px]"> Date de livraison à confirmé lors de la commande (2 - 5 jours)</div>
                            ) : <div className="mt-4 font-bold i bg-[#ffe4b7] px-[5px] py-[2px] rounded-[6px]">
                                * Livraison dès demain (selon votre adresse)
                            </div>
                        }



                        <div className="mt-10">

                            {
                                (el.metadata && el.metadata.externalLink && el.metadata.externalLink.facebook) && (
                                    <iframe
                                        src={el.metadata.externalLink.facebook}
                                        height="591"
                                        className="full"
                                        style={{ width: '100%' }}
                                        scrolling="no"
                                        frameBorder={0}
                                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                    />

                                )
                            }

                        </div>

                            
                        <div className="full mt-4 mx-auto">

                            <WhatsAppButton product={el} />
                        </div>

                        {el.promoPrice >= 800 && (
                            <div className="mt-6 font-bold text-green-600">
                                FREE Delivery <span className="text-gray-700">(2-5 Opening Days)</span>
                            </div>
                        )}

                        <div>
                            <div className="mr-3 mt-6" style={styleBox}>
                                <Image
                                    className="border z-10 "
                                    alt=""
                                    src={'/images/cash-juice.png'}
                                    layout="intrinsic"
                                    width={150} // Optional: Use your image native width
                                    height={100} // Optional: Use your image native height
                                />
                            </div>

                            <div className="mt-6" style={styleBox}>
                                <Image
                                    className="border z-10"
                                    alt=""
                                    src={'/images/free-delivery-fee.png'}
                                    layout="intrinsic"
                                    width={150} // Optional: Use your image native width
                                    height={100} // Optional: Use your image native height
                                />
                            </div>
                        </div>

                        <p className="pt-4">
                            <i>Utilisez les flèches gauche et droite situées en haut pour parcourir l’ensemble des produits.</i>
                        </p>





                    </div>
                </div>
            </div>
        </div>
    );
};

